define(['jquery'], function ($) {
  var sizes = {
    'small-screen': 420,
    'medium-screen': 768,
    'large-screen': 1025,
    'extralarge-screen': 1280,
    'huge-screen': 1440
  }
  var $win = $(window)

  function isSmallerThan (screenSize) {
    if (!screenSize) throw new Error('Screen size not defined')
    return function () {
      return $win.outerWidth() < screenSize
    }
  }
  return {
    sizes: sizes,

    isLessThanSmall: isSmallerThan(sizes['small-screen']),
    isLessThanMedium: isSmallerThan(sizes['medium-screen']),
    isLessThanLarge: isSmallerThan(sizes['large-screen']),
    isLessThanExtraLarge: isSmallerThan(sizes['extralarge-screen']),
    isLessThanHuge: isSmallerThan(sizes['huge-screen'])
  }
})
